import type { FieldMethod } from "../Form/types/types";
import { EditableListAppConfigsDefaultValueEditField } from "./components/ListComponents/EditableListAppConfigsDefaultValueEditField";
import { EditableListAppConfigsValidationsEditField } from "./components/ListComponents/EditableListAppConfigsValidationsEditField";
import { EditableListCheckBoxField } from "./components/ListComponents/EditableListCheckboxField";
import { EditableListDisplayTextField } from "./components/ListComponents/EditableListDisplayTextField";
import { EditableListHiddenCheckBoxField } from "./components/ListComponents/EditableListHiddenCheckboxField";
import { EditableListHiddenInputField } from "./components/ListComponents/EditableListHiddenInputField";
import { EditableListNumberInputField } from "./components/ListComponents/EditableListNumberInputField";
import { EditableListSelectDynamicField } from "./components/ListComponents/EditableListSelectDynamicField";
import { EditableListTextInputField } from "./components/ListComponents/EditableListTextInputField";
import { EditableListFormComponent } from "./types/EditableListFormComponent";

export const EditableListFormFieldsMap: Record<EditableListFormComponent, FieldMethod> = {
    [EditableListFormComponent.SELECT_DYNAMIC]: EditableListSelectDynamicField,
    [EditableListFormComponent.CHECK_BOX]: EditableListCheckBoxField,
    [EditableListFormComponent.TEXT]: EditableListTextInputField,
    [EditableListFormComponent.NUMBER]: EditableListNumberInputField,
    [EditableListFormComponent.HIDDEN_INPUT]: EditableListHiddenInputField,
    [EditableListFormComponent.APPLICATION_CONFIGURATIONS_VALIDATIONS_EDIT]: EditableListAppConfigsValidationsEditField,
    [EditableListFormComponent.APPLICATION_CONFIGURATIONS_DEFAULT_VALUE_EDIT]: EditableListAppConfigsDefaultValueEditField,
    [EditableListFormComponent.DISPLAY_TEXT]: EditableListDisplayTextField,
    [EditableListFormComponent.HIDDEN_CHECK_BOX]: EditableListHiddenCheckBoxField,
};
